import React from 'react';
import { withStyles } from 'material-ui/styles';
import Paper from 'material-ui/Paper';

const styles = theme => ({
  link : {
    textDecoration: 'none',
    color: 'black',
  },
  root:{
    display: 'block',
    overflowX: 'scroll',
  },
  block:{
    display: 'block',
  },
  hlist:{
    display: 'flex',
  },
  hlist_item:{
    display: 'block',
    minWidth: 200,
    padding: 10,
    marginRight: 5,
  },
  title: {
    fontSize: 15,
    lineHeight: '1',  
    marginBottom: 10,  
  },
  rating: {
    fontSize: 10, 
    fontWeight: 'bold',
  },
  date: {
    fontSize: 10, 
    float: 'right',
  },
  author: {
    fontSize: 10, 
    marginBottom: 2,
    color: '#404040',
  },
  body: {
    display: 'block',
    fontSize: 8, 
    lineHeight: '15px',
    textAlign: 'justify',
  },
});


class Review extends React.Component {
  handleListItemClick(url) {
    if(!url) return;
    var win = window.open(url, '_blank');
    win.focus();

    const uri = '/google/q/this';
    const params = {q : '', url: url};
    this.props.server.get(uri, params, null);
    return false;
  }
  
  render() {
    var key = 0;
    const classes = this.props.classes;
    const data = this.props.data;
    const link = data.link;
    const body = 
      <div className={classes.block}>
        <div className={classes.title}>Reviews</div>
        <div className={classes.root}>
          <div className={classes.hlist}>
          {data.reviews.map(item =>
            <Paper key={key++} className={classes.hlist_item}>
              <div>
                <span className={classes.author}>{item.author}</span> <span className={classes.rating}>{item.rating}</span> <span className={classes.date}>{item.datepublished}</span>
              </div>
              <span className={classes.body}>{item.body}</span>
            </Paper>
          )}
          </div>
        </div>
      </div>;    

    return (
      body
    );
  }

}

export default withStyles(styles)(Review);


// WEBPACK FOOTER //
// ./src/search/display/review_extra.js